import { computed, type Ref } from 'vue'
import type { VariantFeedItem } from '#root/types/variants'

export function useVariantHrefs(
  variant: Ref<VariantFeedItem | null | undefined>,
  canonicalPaths: { base: string },
  registerParams?: Ref<[string, string][] | undefined>
) {
  const infoHref = computed(() => {
    const product = variant.value?.product
    if (!product || typeof product !== 'object') return ''
    const occasionTypeCode = product.occasion_type?.code
    const pageSlug = 'page_slug' in product ? product.page_slug : undefined
    if (!pageSlug) return ''

    if (variant.value?.delivery_method?.code === 'D') {
      return `/training/on-demand/${pageSlug}`
    }

    switch (occasionTypeCode) {
      case 'C':
        return `/training/courses/${pageSlug}`
      case 'W':
        return `/training/workshops/${pageSlug}`
      default:
        return ''
    }
  })

  const registerHref = computed(() => {
    if (!infoHref.value || !variant.value?.sku) return ''
    const url = new URL(infoHref.value, canonicalPaths.base)
    url.hash = `h${variant.value.sku}`
    if (registerParams?.value && Array.isArray(registerParams.value)) {
      registerParams.value.forEach(([n, v]) => url.searchParams.set(n, v))
    }
    return url.href
  })

  return {
    infoHref,
    registerHref
  }
}
